<template>
  <Stack direction="col" class="w-full">
    <Stack direction="col" gap="xs" class="w-full px-xs md:px-none">
      <Heading size="md">Invoices and Statement</Heading>
      <Text>Here you can see your account statement, view and download your latest invoices, or make a payment.</Text>
    </Stack>

    <SimpleCard slot-class="!px-none !pt-none md:!p-md">
      <SkeletonLoader v-if="!displayContent" class-name="h-[560px]" />

      <NoPermission v-if="displayContent && !canViewPage" class="h-[640px]" />

      <Tabs
        v-if="displayContent && canViewPage"
        class="items-stretch md:items-start"
        slot-class="w-full"
        align="center"
      >
        <Tab title="Invoices" data-test-id="invoicesTab">
          <InvoicesTab />
        </Tab>
        <Tab title="Statement" data-test-id="statementTab">
          <StatementTab />
        </Tab>
      </Tabs>
    </SimpleCard>
  </Stack>
</template>

<script lang="ts" setup>
definePageMeta({
  layout: "account",
  middleware: ["is-authenticated"],
});

const { user, isAdmin, isCredit } = useUser();
const { accountBranch, fetchAccountBranch } = useBranches();
const { documentsSearchResult, errorFetchingDocuments, fetchDocuments, loadingDocuments, deselectDocuments } =
  useDocuments();
const { accountSummary, errorFetchingStatement, fetchStatement, loadingStatement } = useStatement();

const canViewPage = computed(() => isAdmin.value && isCredit.value);

const displayContent = computed(
  () =>
    ((user.value && accountBranch.value && documentsSearchResult.value && accountSummary.value) ||
      errorFetchingDocuments.value ||
      errorFetchingStatement.value) &&
    !loadingDocuments.value &&
    !loadingStatement.value,
);

watchEffect(async () => {
  if (user.value && !accountBranch.value) {
    await fetchAccountBranch();
  }
});

onMounted(async () => {
  await nextTick(async () => await Promise.all([fetchDocuments(), fetchStatement(), deselectDocuments()]));
});
</script>
